import Services from '../../services';

class PengakuanHutangApi {
  // API SERVER
  get(params) {
    return Services.get('hrdu/approval_jurnal_umum/list', { params });
  }

  getHistory(params) {
    return Services.get('hrdu/approval_jurnal_umum/history/list', { params });
  }

  getSingle(params) {
    return Services.get('hrdu/approval_jurnal_umum/detail', { params });
  }

  approve(data) {
    return Services.post('hrdu/approval_jurnal_umum/approve', data);
  }
}

export default new PengakuanHutangApi();
